import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
//import {  FormGroup, Validators, FormControl  } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalService } from '../global-service.service';
import { RouterModule, Routes, Router } from '@angular/router';
import { ActivatedRoute, Params} from '@angular/router';
//import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../format-datepicker';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { MatDatepickerInputEvent} from '@angular/material/datepicker';
import { MatExpansionPanel } from '@angular/material/expansion';
import { animate, state, style, transition, trigger} from '@angular/animations';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import * as FileSaver from 'file-saver';


@Component({
    selector: 'app-schadenfall',
    templateUrl: './schadenfall.component.html',
    styleUrls: ['../css/pasura.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*', minHeight: '50px' })),
            transition('expanded <=> collapsed', animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})


export class SchadenfallComponent {

	@Input() polDaten:any; 
	@Input() PasuraBackOfficeUser=false;
	
	tabExpPSR_ID=0;
	schadenfall:any;
	schadenfallOrg="";
	schadenfallID=-1;
	editSchadenfall=false;
	ibanOK=true;
	docEdit=false;
	
	displColRechnungen=[	{"Titel":"Datum",						"Name":"DatumRechnungFormated",	"Number":false },
								{"Titel":"Leistungserbringer",	"Name":"Leistungserbringer",		"Number":false}, 
								{"Titel":"Betrag",					"Name":"BetragRechnungF",			"Number":true},								
								{"Titel":"Leistung",					"Name":"LeistungF", 					"Number":true},
								{"Titel":"Dokument",					"Name":"", 								"Number":false},
								{"Titel":"",							"Name":"Status", 						"Number":false}
							 ];
								
	displColRechnungenName=["DatumRechnungFormated","Leistungserbringer","BetragRechnungF", "LeistungF", "Status"];
								
	
	newDocumentLeer={
						"ID":-1,
						"Typ": "Rechnung",
						"Leistungserbringer":"",
						"Bemerkung":"",	
						"Datum":"",
						"Betrag":0,
						"SchadenfallID":0,
						"OK":false			
					};
	newDocument= Object.assign({},this.newDocumentLeer);
	DocumentFile:File;
	workerWait=false;
					
	
	@ViewChild('TextAreaBeschreibung', 		{static: false}) TextAreaBeschreibung : 	ElementRef;
	@ViewChild('TextAreaBeschreibungRG', 	{static: false}) TextAreaBeschreibungRG : ElementRef;
	@ViewChild('panelNewSchadenfall',  		{static: false}) panelNewSchadenfall : 	MatExpansionPanel;
	
	formatterMoney = new Intl.NumberFormat('de-CH', {
  			style: 'currency',
  			currency: 'CHF',
  			minimumFractionDigits: 2});
  			
  	formatterDecimal = new Intl.NumberFormat('de-CH', {
  			style: 'decimal',
  			minimumFractionDigits: 2});
	
	constructor(public globserv: GlobalService,  private router: Router, private route:ActivatedRoute, private dateAdapter: DateAdapter<any>,private http: HttpClient, private toastr: ToastrService)
  	{  	
  	}
  	
  	
  	ngOnInit() 
  	{
  		console.log("Schadenfall OnInit A");
  		this.dateAdapter.setLocale('de-DE');
  		if (this.polDaten==undefined && this.globserv.APPLICATION=='Pasura-Service')
  		{
  			console.log("Schadenfall OnInit B");
			this.router.navigate(['police']);   		
  		}

		console.log("Schadenfall OnInit C");
  		this.route.params.subscribe((params: Params) => 
  		{
  				console.log("Schadenfall OnInit D");
  				//console.log("polDaten->" +JSON.stringify( this.polDaten));
  				const id= Number( params["ID"]);
  				console.log("ID->" + id);
  				if (id!=undefined && !isNaN(id) )
  				{
  					
  					
					if (id>=0 )
					{
						this.schadenfallID=id;
						this.polDaten= this.globserv.polDaten;
						this.schadenfall= Object.assign({}, this.polDaten.Schadenfaelle[id]);	
						//console.log(JSON.stringify(this.polDaten.Schadenfaelle));
								
					}else{
					
						const pferd = this.polDaten.Pferde[0-id];			
						this.schadenfall={	"PferdID": pferd.id,
											      "Datum": "",
											      "Status": "0",
											      "Art":"",
											      "Beschreibung": "",
											      "Name": pferd.Name,
											      "NameZusatz": pferd.NameZusatz,
											      "GebDat": pferd.GebDat,
											      "PassChip": pferd.PassChip,
											      "VProdukt": pferd.VProdukt,
											      "Optionen": pferd.Optionen
											   };
					} 
  				}else if (this.polDaten!=undefined && this.polDaten.Schadenfaelle!=undefined && this.polDaten.Schadenfaelle.length>0)
  				{
  					
  					this.schadenfall=this.polDaten.Schadenfaelle[0];
  					this.schadenfallID=this.schadenfall.ID;
  				}
  		});
  		
  		if (this.schadenfall!=undefined)
  		{
	  		this.editSchadenfall = this.schadenfall.Art.length ==0;	
	  		if (!this.schadenfall.ExistInfos)
	  		{
	  			this.loadSchadenfallInfos();
	  		}		
	  	}else{
	  		this.editSchadenfall =false;
	  	}	
 	}
 	
 	
	onValueChange(event: Event): void 
 	{
   	console.log(event.target);
    	const value = (event.target as any).value;
    	this.schadenfall.Beschreibung = value;
    	if (this.TextAreaBeschreibung!=undefined)
    	{
    		this.TextAreaBeschreibung.nativeElement.style.height = "0px";
  			this.TextAreaBeschreibung.nativeElement.style.height = (this.TextAreaBeschreibung.nativeElement.scrollHeight + 5)+"px";
  		}
  		this.validateFormData();
  	}
  	
  	onValueChangeRG(event: Event): void 
 	{
   	console.log(event.target);
    	const value = (event.target as any).value;
    	//this.schadenfall.Beschreibung = value;
    	if (this.TextAreaBeschreibungRG!=undefined)
    	{
    		this.TextAreaBeschreibungRG.nativeElement.style.height = "0px";
  			this.TextAreaBeschreibungRG.nativeElement.style.height = (this.TextAreaBeschreibungRG.nativeElement.scrollHeight + 5)+"px";
  		}
  		this.validateFormData();
  	}
  	
  	getTypOfDatum(x)
  	{
		return x instanceof Date;
  	}
  	
  	onFileSelected(event)
  	{
  		this.DocumentFile = event.target.files[0];
  		console.log( "File= " + JSON.stringify(this.DocumentFile));
  		this.validateFormData();
  	}
  	
  	setDatum(ev)
  	{
		this.newDocument.Datum=this.globserv.getJsonDate(ev.value);		
		this.validateFormData();
  	}
  	
  	validateFormData()
  	{
  		console.log("validateFormData " + this.newDocument.Typ  );
  		var file=false;
  		
  		if (this.DocumentFile || this.schadenfall.Art=='Todesfall' || this.docEdit) 
  		{
  			file =true;
  		}
  		
  		if (this.newDocument.Typ != 'Rechnung')
  		{
				this.newDocument.OK= this.newDocument.Bemerkung.length>4 && file;
				
				console.log("validateFormData A " + this.newDocument.OK );
				return  this.newDocument.OK;
  		}

		

		if (this.newDocument.Typ=='Rechnung')
		{   		
  		
			this.newDocument.OK=this.newDocument.Datum.length>9 && 	
					this.newDocument.Leistungserbringer.length>4 && file && 
					this.newDocument.Betrag>0 && 
					this.isNaN_(this.newDocument.Betrag)			
					;
					
				
			console.log("validateFormData B " + this.newDocument.OK );
			
			return this.newDocument.OK;
		} 	
		
		console.log("validateFormData C " + this.newDocument.OK );
		return this.newDocument.OK;
  	}
  	
  	sendNewDocument(update=false)
  	{
  		
  		if (this.DocumentFile !=undefined || this.docEdit) 
  		{
  			 var resultData;
  			 
  			 this.workerWait=true;
  			 this.newDocument.SchadenfallID=  Number(this.schadenfall.ID);
  			 const formData = new FormData();
          formData.append("thumbnail", this.DocumentFile);
          formData.append("json",JSON.stringify( this.newDocument));
          formData.append("Update",update?"true":"false");
          
          const upload$ = this.http.post(this.globserv.BACKENDBASE + "/v1/sendSFDocument", formData);
          upload$.subscribe(
				result => 
		  					resultData = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				this.workerWait=false;
		  					 		  },
		       () => {
		       		console.log(JSON.stringify(resultData));
		       		this.workerWait=false;
		       		if (resultData.Status)
		       		{
								
							this.schadenfall=resultData.Schadenfaelle[0];
							this.updatePolDaten(this.schadenfall , this.schadenfallID);
							
							this.docEdit=false;
							this.newDocument=Object.assign({},this.newDocumentLeer);
							this.DocumentFile=null;
							
							
							if (this.panelNewSchadenfall!=undefined)
							{
								this.panelNewSchadenfall.close();
							}
		       		}
		       }
		  );     	
          
 	 	}
 	 	
  		console.log(this.newDocument);
  	}
  	
  	 pickerEvent(event: MatDatepickerInputEvent<Date>) {
  	 	
  	 		console.log("Event -> " +event);
        this.newDocument.Datum = event.value.toISOString();
    }
    
   
    saveSchadenfallDaten()
    {
    	
    	console.log("saveSchadenfallDaten");
    	
    	var resultData;
  		var data= Object.assign({},this.schadenfall);
  		this.workerWait=true;
  		
  		if (this.ibanOK)
  		{
  			data.IBAN = this.polDaten.IBAN;
  		}
    	
    	console.log("PolDaten befor POST " + JSON.stringify(this.polDaten));
    	console.log("Schadenfall befor POST " + JSON.stringify(data));
  		
  		this.globserv.getBackendData("/v1/saveSchadenfallDaten",data).subscribe (
			result => 
		  					resultData = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				this.workerWait=false;
		  					 		  },
		       () => {
		       		console.log(JSON.stringify(resultData));
		       		if (resultData.OK)
		       		{
							this.editSchadenfall=false;
							this.schadenfall.GJ_ID=resultData.GJ_ID;
							this.schadenfall.PreFix=resultData.PreFix;
							this.schadenfall.Pfad=resultData.Pfad;
							this.schadenfall.MaxLeistung=resultData.MaxLeistung;
							this.schadenfall.Selbstbehalt=resultData.Selbstbehalt;
						}
		       		
		       		if (this.schadenfall!=undefined && this.schadenfall.Rechnungen.length==0)
		       		{
							this.newDocument= Object.assign({},this.newDocumentLeer);	
							
							this.tabExpPSR_ID=-1;
							this.editSchadenfall=false;
							
							this.toastr.success("Vielen Dank.\nIhr Schadenfall wurde nun erstellt. Sie Können mit dem Link Ihren Schadenfall jederzeit wieder öffnen und weiter bearbeiten.", "Info", { disableTimeOut: true, positionClass: "toast-top-right"});    		
		       		}
		       		
		       		this.workerWait=false;
		       }
		       
		       
		  );  
		  
		     	
    }
  	
  	 loadSchadenfallInfos()
    {
    	if (this.PasuraBackOfficeUser)
    	{
	    	this.schadenfall.ExistInfos=false;
			this.schadenfall.ExistAbrechnungDocX=false;
			this.schadenfall.ExistAbrechnungPDF=false;
			this.schadenfall.ExistBexioBill=false;
			this.schadenfall.ExistBexioFile=false;
			this.schadenfall.BexioBillStatus="";
			
	    	
			var resultData;
	  		var data=  Object.assign({}, this.schadenfall);
	  		if(this.globserv.Login!=undefined)
	  		{
				data.UnterschriftName=this.globserv.Login.UnterschriftName;
				data.UnterschriftTitel=this.globserv.Login.UnterschriftTitel;	  		
	  		
	  		}
	  		
	  		this.globserv.getBackendData("/v1/getSchadenfallInfos",data).subscribe (
				result => 
			  					resultData = result,
			  					
			  					 err => {
			  					 				console.log("Error");
			  					 				console.log(err);
			  					 		  },
			       () => {
			       	       	
			       		console.log("loadSchadenfallInfos > " + JSON.stringify(resultData));
			       		if (resultData.OK)
			       		{
								this.schadenfall.ExistInfos=true;
								this.schadenfall.ExistAbrechnungDocX=resultData.ExistAbrechnungDocX;
								this.schadenfall.ExistAbrechnungPDF=resultData.ExistAbrechnungPDF;
								this.schadenfall.ExistBexioBill=resultData.ExistBexioBill;
								this.schadenfall.ExistBexioFile=resultData.ExistBexioFile;
								this.schadenfall.BexioBillStatus=resultData.BexioBillStatus;
			       		}			       		
			       }
			  );  
		 }   	
    }
  	getDateSchadenfallEreingnis()
  	{
  		var d= new Date( Date.parse (this.schadenfall.DatumEreignis));
  		console.log(d.toISOString());
  		return d;
  	}
  	
  	isNaN_(x)
  	{
  			
		return typeof x === 'number';
  	}
  	
  	createBexioZahlung()
  	{
  		this.workerWait=true;
    	
		var resultData;
  		var data=  Object.assign({}, this.schadenfall);
  		
  		
  		this.globserv.getBackendData("/v1/createBexioZahlung",data).subscribe (
			result => 
		  					resultData = result,
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				 this.workerWait=false;
		  					 		  },
		       () => {
		       	
		       		 console.log(JSON.stringify(resultData));
		       		 this.workerWait=false;
		       		if (resultData.OK)
		       		{
							this.schadenfall.ExistAbrechnungDocX=true;   			
							this.schadenfall.ExistAbrechnungPDF=true;
							//this.schadenfall.ExistBexioZahlung=true;
							this.schadenfall.ExistBexioBill=true;
		       		}
		       		
		       		console.log(JSON.stringify(this.schadenfall));
		       }
		  );
	}
  	
  	createAbrechnungDocX(onlyPDF=false)
  	{
  		    	
  		this.workerWait=true;
    	
		var resultData;
  		var data=  Object.assign({}, this.schadenfall);
  		
		data.UnterschriftName=this.globserv.Login.UnterschriftName;
		data.UnterschriftTitel=this.globserv.Login.UnterschriftTitel;	  	
			
  		data.onlyPDF= onlyPDF;
  		
  		this.globserv.getBackendData("/v1/createAbrechnungDocX",data).subscribe (
			result => 
		  					resultData = result,
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				 this.workerWait=false;
		  					 		  },
		       () => {
		       		console.log(JSON.stringify(resultData));
		       		
		       		if (resultData.OK)
		       		{
		       			if (resultData.Schadenfall!=undefined)
		       			{
		       				this.schadenfall=resultData.Schadenfall;
		       				
  								this.loadSchadenfallInfos();
  			
		       			}
		       		}
		       		this.workerWait=false;
		       }
		  );
  	}
  	
  	savePositionExpPSR()
  	{
  		var row = this.schadenfall.Rechnungen.find(rg => rg.PSR_ID === this.tabExpPSR_ID);
				
		if (this.DocumentFile!=undefined)
  		{
  			this.newDocument.ID= Number(row.PSR_ID);
  			this.sendNewDocument(true);
  		}else{
  		
  		}
  		this.savePosition(row);  		
  	}
  	
  	savePosition(pos)
  	{
  		console.log(JSON.stringify(pos));
  		var changeWorker = !this.workerWait;   
  		
  		
  		
  		if ((this.PasuraBackOfficeUser && Number(pos.Status)<2) ||  Number(pos.Status)==0 )
  		{
	  		this.workerWait=true;
	  		
	  		if (pos.PSR_ID==this.tabExpPSR_ID )
	  		{
	  			console.log("click savePosition");
	  			
				this.tabExpPSR_ID=-1;
				var resultData;
	  			var data= pos;
	  		
	  			this.globserv.getBackendData("/v1/savePosition",data).subscribe (
					result => 
			  					resultData = result,
			  					
			  					 err => {
			  					 				console.log("Error");
			  					 				console.log(err);
			  					 		  },
			       () => {
			       		//console.log(JSON.stringify(resultData));
			       		if (resultData.OK)
			       		{
								this.schadenfall=resultData.Schadenfaelle[0];
								this.updatePolDaten(this.schadenfall , this.schadenfallID);	 
								this.loadSchadenfallInfos();      			
			       		}
			       }
			  	);
				
			}else {
					
				//if (pos.Typ=='Rechnung')
				{
					this.tabExpPSR_ID=pos.PSR_ID;
				}
			} 
			
			if(changeWorker)
			{ 
				this.workerWait=false;
			}	
	  	}
	}
	
	addPosition(PSF_ID, PSR_ID)
  	{
  		this.workerWait=true;
  		
  		if (this.PasuraBackOfficeUser)
  		{
  			var resultData;
  			var data= {"PSR_ID":PSR_ID, "PSF_ID":PSF_ID};
  		
  			this.globserv.getBackendData("/v1/addPosition",data).subscribe (
			result => 
		  					resultData = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				this.workerWait=false;
		  					 		  },
		       () => {
		       		console.log(JSON.stringify(resultData));
		       		this.workerWait=false;
		       		if (resultData.OK)
		       		{
							this.schadenfall=resultData.Schadenfaelle[0];		
							this.updatePolDaten(this.schadenfall , this.schadenfallID);    			
		       		}
		       }
		  );  	
	  	}
	}
	
	addPosition__(PSR_ID)
	{
		var rechnung = this.schadenfall.Rechnungen.find(rg => rg.PSR_ID === this.tabExpPSR_ID);
  		
  		var data={	"PSA_ID": "-1",
      			 	"PSR_ID": "PSR_ID",
				      "Position": (rechnung.Positionen.length+1).toString(),
				      "Typ": "2",
				      "Text": "",
				      "Betrag": "0"
				    } ;
			
		console.log(JSON.stringify(rechnung));	    
  		rechnung.add(data);
  	}
      
	
	schadenfallAbschliessen()
	{
		
    	this.toastr.info("Bitte beachten Sie, dass für die Prüfung und Abrechnung von Behandlungskosten zwingend eine tierärztliche Schadenmeldung oder ein vergleichbarer Tierarztbericht einzureichen ist.", "Info", 
    	{ disableTimeOut: true, positionClass: "toast-center-center"});
		
		console.log(JSON.stringify(this.schadenfall));	
		var resultData;
  			var data= {"PSF_ID":this.schadenfall.ID, "AbrechnungIDX": this.schadenfall.AbrechnungIDX};
  		
  			this.globserv.getBackendData("/v1/schadenfallAbschliessen",data).subscribe (
				result => 
	  					resultData = result,
	  					
	  					 err => {
	  					 				console.log("Error");
	  					 				console.log(err);
	  					 		  },
	       () => {
	       		console.log(JSON.stringify(resultData));
	       		if (resultData.OK)
	       		{
						this.schadenfall=resultData.Schadenfaelle[0];
						this.updatePolDaten(this.schadenfall , this.schadenfallID);  			
	       		}
	       }
	  );  	
  	}

	schadenfallSetStatus(status, reopen=false )
	{
		var idx = this.schadenfall.AbrechnungIDX;
		if (reopen)
		{
			idx=-100;
		}
		
		console.log(JSON.stringify(this.schadenfall));	
		var resultData;
  			var data= {"PSF_ID":this.schadenfall.ID, 
  			"AbrechnungIDX": idx, 
  			"Status":Number(status),
  			"StatusAktuell":Number(this.schadenfall.PSF_Status),
  			"ReOpen": reopen};
  		
  			this.globserv.getBackendData("/v1/schadenfallSetStatus",data).subscribe (
				result => 
	  					resultData = result,
	  					
	  					 err => {
	  					 				console.log("Error");
	  					 				console.log(err);
	  					 		  },
	       () => {
	       		console.log(JSON.stringify(resultData));
	       		if (resultData.OK)
	       		{
						this.schadenfall=resultData.Schadenfaelle[resultData.Schadenfaelle.length-1];
						this.updatePolDaten(this.schadenfall , this.schadenfallID);  			
	       		}
	       		
	       		if (status>-1)
	       		{
	       			this.loadSchadenfallInfos();
	       		}     
	       }
	  );  	
  	}
	
	
	
	editRechnung(event, rg)
	{
		console.log(JSON.stringify(rg));
		event.stopPropagation();	
		
		//if(Number(rg.Status)<2)
		{		
		  console.log("Hallo");
			this.newDocument={
							"ID": rg.PSR_ID,
							"Typ": rg.Typ,
							"Leistungserbringer":rg.Leistungserbringer,
							"Bemerkung":"",	
							"Datum":rg.DatumRechnung,
							"Betrag":rg.BetragRechnung,
							"SchadenfallID":rg.PSF_ID,
							"OK":false			
						};
						
			this.tabExpPSR_ID=rg.PSR_ID;
		}
	}	
	
  updatePolDaten(daten, id)
  {
  		this.polDaten.Schadenfaelle[id]= Object.assign({},daten);
  }
  
  toCHDateFormat(d)
  {
  		var arr=d.split('-');
  		if (arr.length==3)
  		{
  			return [arr[2], arr[1], arr[0]].join('.');
  		}
  		return d;
  }
  
  doEditSchadenfall()
  {
   	//this.schadenfallOrg = JSON.stringify(this.schadenfall);
  		this.editSchadenfall=!this.editSchadenfall;
  		console.log("this.schadenfallOrg ->" + this.schadenfallOrg);
  }
  
  

  cancelEditSchadenfall()
  {
  		console.log("this.schadenfallOrg ->" + this.schadenfallOrg);
  		if (this.schadenfallOrg!="")
  		{
   		this.schadenfall = JSON.parse(this.schadenfallOrg);
   	}
   	this.editSchadenfall=false;
  }
  
  isChangedSchadenfall()
  {
  		return this.schadenfallOrg != JSON.stringify(this.schadenfall);
  }
  
  formatMoney(d)
  {
		  return this.formatterMoney.format(d);
  }
  
  formatDecimal(d)
  {
		  return this.formatterDecimal.format(d);
  }

  SchadenfallDatenOK()    
  {
  		if (this.schadenfall.DatumEreignis.length <10 )
  		{
  			console.log("DatumEreignis NOK");
			return false;  		
  		}
  		
  		if (this.schadenfall.Art.length <3 )
  		{
  			console.log("Art NOK");
			return false;  		
  		}
  		
  		if (this.schadenfall.Beschreibung.length <3 )
  		{
  			console.log("Beschreibung NOK => " + this.schadenfall.Beschreibung);
			//return false;  		
  		}
  		
  		if (!this.ibanOK )
  		{
  			console.log("IBAN NOK");
			return false;  		
  		}
  		
  		
  		return true;
  }
  
  checkIBAN()
  {
  		
  		if (this.polDaten.IBAN.replace(/ /gi, "").length==21)
  		{
			var resultData;
  			var data= {"IBAN":this.polDaten.IBAN};
  		
  			this.globserv.getBackendData("/v1/checkIBAN",data).subscribe (
				result => 
	  					resultData = result,
	  					
	  					 err => {
	  					 				console.log("Error");
	  					 				console.log(err);
	  					 		  },
	       	() => {
	       		console.log(JSON.stringify(resultData));
	       		this.ibanOK=resultData.OK;
	       		this.validateFormData();
						       		
	       		console.log("checkIBAN " +this.ibanOK);
	       		
	       	}
	  		);  	

  		}else{
  			
			this.ibanOK=false;  	
			this.validateFormData();	
  		}
  		
  		console.log("checkIBAN " +this.ibanOK);
  }
  
  getColSpan(row, col)
  {
  		
  		if ((row.Typ=='Unterlagen' || row.Typ=='Tierarztbericht') && col=='Leistungserbringer')
  		{
			return 3;  		
  		}
  		
  		if ((row.Typ=='Unterlagen' || row.Typ=='Tierarztbericht') && (col=='BetragRechnungF' || col=='LeistungF'))
  		{
  			return 0;
  		}
  		return 1;
  }
  
  showDocument__(element)
  {
		var data= {"Document":element, "Pfad": this.schadenfall.Pfad};
		
		
		this.http.post(this.globserv.BACKENDBASE+ "/v1/getDocument",data, { responseType: 'blob'  })
		      .subscribe((response: any) => {
            	 
            	//const contentDispositionHeader: string = response.headers.get('Disposition');
    				//const parts: string[] = contentDispositionHeader.split(';');
    				const filename = element.FileName;
    				const blob = new Blob([response.body],{type: "Application/jpg"});
    				//const blob = new Blob([response.body], { type: 'text/plain' });
            	FileSaver.saveAs(blob, "test.docx");
            	 
                FileSaver.saveAs(blob, filename);
            });
   }	
   
   
  async showDocument(element)
  {
		var data= {"Document":element, "Pfad": this.schadenfall.Pfad};
		this.workerWait=true;
				
		try {
      
      	this.downloadFile(await this.http.post(this.globserv.BACKENDBASE+ "/v1/getDocument", data, {responseType: 'blob' }).toPromise());
      	
  		} catch (e) {
  		   
  		   this.workerWait=false;
      	console.log(e);
  		}
			
  }
  
  	downloadFile(data) 
	{
		  this.workerWait=false;
        const url = window.URL.createObjectURL(data);
        window.open(url);
  	} 
    
   setArt(art)
	{
		if (this.schadenfall.Art!=art)
		{
			this.schadenfall.Art=art;
			//this.schadenfall.PreFixOld=this.schadenfall.PreFix;		
			this.schadenfall.PreFix="";
		}
	}
	
  showDeleteSchadenfallToaster()
  {
   
    this.toastr.success("",'Schadenfall wirklich löschen?',
    {
        closeButton: false,
        enableHtml:false,
        progressBar:true,
        timeOut:6000,
        extendedTimeOut:6000       
        
    }).onTap.pipe(take(1) as any).subscribe(() => this.deleteSchadenfall());
 
  } 
  
  deleteSchadenfall()
  {
  		this.schadenfallSetStatus(-1);
  		
  		this.schadenfall= undefined;
		this.schadenfallOrg="";
		this.schadenfallID=-1;
		this.editSchadenfall=false;
		
		this.globserv.setPasuraAction('closeSchadenfall;');
  		
  }
  
  setDocEdit(docData)
  {
  		this.newDocument= Object.assign({},docData);
  		this.newDocument.Datum = docData.DatumRechnung;
  		this.docEdit=true;
  }
}

